import React from "react";
import { CONSTANTS } from "../utils/constants";
import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
} from "@react-pdf/renderer";
import { parseDocument } from "htmlparser2";
import { DomUtils } from "htmlparser2";

const styles = StyleSheet.create({
  page: {
    padding: 30,
    fontSize: 12,
    fontFamily: "Helvetica",
  },
  babText1: {
    fontSize: 16,
    marginBottom: 5,
    textAlign: "center",
    fontWeight: "bold",
  },
  babText2: {
    fontSize: 16,
    marginBottom: 20,
    textAlign: "center",
    fontWeight: "bold",
  },
  title: {
    fontSize: 14,
    textAlign: "center",
    marginBottom: 20,
    fontWeight: "bold",
  },
  questionBlock: {
    marginBottom: 10,
    borderBottom: "1px solid #ccc",
    paddingBottom: 6,
  },
  questionText: {
    flex: 1,
    fontSize: 12,
    marginBottom: 4,
  },
  answerText: {
    flex: 1,
    fontSize: 12,
    color: "#2b2b2b",
  },
  resultText: {
    fontSize: 12,
    marginTop: 4,
  },
  dateText: {
    fontWeight: 'bold',
    fontSize: 12,
    marginTop: 10,
    textAlign: 'right',
  },
  interpretationText: {
    fontSize: 12,
    color: "#f44336",
    fontWeight: 'bold',
    marginTop: 4,
    marginBottom: 20,
  },
  questionRow: {
    flexDirection: 'row',
    alignItems: 'flex-start',
  },
  questionNo: {
    width: 30,
    color: 'gray',
    textAlign: 'center'
  },
  italic: { fontStyle: "italic" },
  bold: { fontWeight: "bold" },
  underline: { textDecoration: "underline" },
  footer: {
    position: "absolute",
    bottom: 15,
    left: 0,
    right: 0,
    textAlign: "center",
    fontSize: 10,
    color: "grey",
  }
});

const today = new Date().toLocaleDateString("en-GB", {
  day: "2-digit",
  month: "long",
  year: "numeric"
});

function renderHTMLtoPDF(html, styles) {
  const doc = parseDocument(html);
  const elements = DomUtils.getChildren(doc);

  const renderNodes = (nodes) => {
    return nodes.map((node, i) => {
      if (node.type === "text") {
        return <Text key={i}>{node.data}</Text>;
      }
      if (node.type === "tag") {
        const children = renderNodes(node.children || []);
        switch (node.name) {
          case "i":
            return (
              <Text key={i} style={styles.italic}>
                {children}
              </Text>
            );
          case "b":
          case "strong":
            return (
              <Text key={i} style={styles.bold}>
                {children}
              </Text>
            );
          case "u":
            return (
              <Text key={i} style={styles.underline}>
                {children}
              </Text>
            );
          default:
            return <Text key={i}>{children}</Text>;
        }
      }
      return null;
    });
  };

  return renderNodes(elements);
}

const TestPdfDocument = ({ test, responses, results }) => {
  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <Text style={styles.babText1}>{CONSTANTS.BAB1}</Text>
        <Text style={styles.babText2}>{CONSTANTS.BAB2}</Text>
        <Text style={styles.title}>{test.title} {CONSTANTS.RESULTS}</Text>
        <Text style={styles.resultText}>
          Score is {results.score}
        </Text>
        <Text style={styles.resultText}>{results.description ? results.description : 'Interpretation could not be generated...'}</Text>;
        <Text style={styles.interpretationText}>{results.interpretation ? results.interpretation : ''}</Text>

        {test.questions.map((q, i) => (
          <View key={i} style={styles.questionBlock} wrap={false}>
            {/* Question row */}
            <View style={styles.questionRow}>
              <Text style={styles.questionNo}>Q{`${i + 1})`}</Text>
              <Text style={styles.questionText}>
                {renderHTMLtoPDF(`${test.questionPrefix} ${q.text}`, styles)}
              </Text>
            </View>

            {/* Answer row */}
            <View style={styles.questionRow}>
              <Text style={styles.questionNo}>A.</Text>
              <Text style={styles.answerText}>
                {responses[i] > -1
                  ? test.options.find((it) => it.point === responses[i])?.value || ''
                  : CONSTANTS.NORESPONSE}
              </Text>
            </View>
          </View>
        ))}
        <Text style={styles.dateText}>{`Test answered on: ${today}`}</Text>
        <Text
          style={styles.footer}
          render={({ pageNumber, totalPages }) =>
            `Page ${pageNumber} of ${totalPages}`
          }
          fixed
        />
      </Page>
    </Document>
  )
};

export default TestPdfDocument;
